import { judete } from './siruta-data.json'

const getLocBySiruta = (codLoc) => {
    for (const judet of judete) {
        const loc = judet.localitati.find(l => l.siruta === +codLoc)
        if (loc) {
            return { localitate: loc.name, judet: judet.name }
        }
    }
    return null
}

export default getLocBySiruta